import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { IMaskInput } from 'react-imask';
import { useSelector, useDispatch } from 'react-redux';

import Box from '@mui/material/Box';
import { Input, IconGraphy, Button } from '@leapeasy/ui-kit';
import { CustomInputWrapper } from 'components/CustomWrapper';
import { validationMessages } from 'utils/validationMessages';

import { setDataAction } from 'redux/actions/shortFormActions';
import GoogleAutoComplete from '../../components/GoogleAutoComplete';

const Form5 = (props) => {
  const { handleNext, handleBack } = props;
  const dispatch = useDispatch();
  const formData = useSelector((state) => state.shortFormData);

  const [data, setFormData] = useState({
    street: null,
    unit: null,
    city: null,
    state: null,
    postalCode: null,
    country: null,
  });

  useEffect(() => {
    setFormData({
      street: formData.data.currentStreet,
      unit: formData.data.currentUnit,
      city: formData.data.currentCity,
      state: formData.data.currentState,
      postalCode: formData.data.currentPostalCode,
      country: formData.data.currentCountry,
    });
  }, [formData]);

  const handleAddress = (value) => {
    const { short_name: state = '' } =
      value.address_components.find((c) => c.types.includes('administrative_area_level_1')) || {};
    const { short_name: city = '' } =
      value.address_components.find((c) => c.types.includes('locality')) || {};
    const { short_name: streetNumber = '' } =
      value.address_components.find((c) => c.types.includes('street_number')) || {};
    const { short_name: route = '' } =
      value.address_components.find((c) => c.types.includes('route')) || {};
    const { long_name: postalCode = '' } =
      value.address_components.find((c) => c.types.includes('postal_code')) || {};
    const { long_name: country = '' } =
      value.address_components.find((c) => c.types.includes('country')) || {};

    setFormData({
      ...data,
      street: streetNumber + ' ' + route,
      city: city,
      state: state,
      postalCode: postalCode,
      country: country,
    });
  };

  const handleChange = (e, label) => {
    const value = e.target.value;
    setFormData({ ...data, [label]: value });
  };

  const handleNextButton = () => {
    dispatch(
      setDataAction({
        ...formData.data,
        currentStreet: data.street,
        currentUnit: data.unit,
        currentCity: data.city,
        currentState: data.state,
        currentPostalCode: data.postalCode,
        currentCountry: data.country,
      }),
    );
    handleNext();
  };

  return (
    <Fragment>
      <Box display="flex" flexDirection="column" gap="4px">
        <Box mb={2}>
          <GoogleAutoComplete
            address1={data.street}
            handleAddress={(value) => handleAddress(value)}
            handleStreet={(value) => setFormData({ ...data, street: value })}
          />
        </Box>
        <CustomInputWrapper>
          <Input
            value={data.unit}
            onChange={(e) => handleChange(e, 'unit')}
            label="Unit#"
            helperMessage={validationMessages.optional}
            type="text"
            icon={<IconGraphy icon="HomePlaces.Apartment" />}
            minWidth="100%"
            size="medium"
            fullWidth
            showCopy={false}
          /></CustomInputWrapper>
        <CustomInputWrapper>
          <Input
            value={data.city}
            onChange={(e) => handleChange(e, 'city')}
            label="City"
            type="text"
            icon={<IconGraphy icon="MapTravel.PinDrop" />}
            minWidth="100%"
            size="medium"
            fullWidth
            showCopy={false}
          /></CustomInputWrapper>
        <CustomInputWrapper>
          <Input
            value={data.state}
            onChange={(e) => handleChange(e, 'state')}
            label="State/Province"
            type="text"
            icon={<IconGraphy icon="MapTravel.Map" />}
            minWidth="100%"
            size="medium"
            fullWidth
            showCopy={false}
          /></CustomInputWrapper>
        <CustomInputWrapper>
          <Input
            value={data.postalCode}
            onChange={(e) => handleChange(e, 'postalCode')}
            label="Postal Code"
            type="text"
            icon={<IconGraphy icon="MapTravel.PostOffice" />}
            minWidth="100%"
            size="medium"
            fullWidth
            showCopy={false}
          /></CustomInputWrapper>
        <CustomInputWrapper>
          <Input
            value={data.country}
            onChange={(e) => handleChange(e, 'country')}
            label="Country"
            type="text"
            icon={<IconGraphy icon="MapTravel.Public" />}
            minWidth="100%"
            size="medium"
            fullWidth
            showCopy={false}
          /></CustomInputWrapper>
      </Box>

      <Box
        sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', mt: 4, gap: '16px' }}
      >
        <Button size="medium" variant="secondary" onClick={handleBack} style={{ flexShrink: 2 }}>
          Back
        </Button>

        <Button
          size="medium"
          onClick={handleNextButton}
          disabled={!(data.street && data.state && data.city && data.postalCode && data.country)}
          style={{ flexShrink: 1 }}
        >
          Next
        </Button>
      </Box>
    </Fragment>
  );
};

export default Form5;
